module.exports = __webpack_public_path__ + "img/poster.66886755.jpg";